import script from "./AccountLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountLayout.vue?vue&type=script&setup=true&lang=js"

import "./AccountLayout.vue?vue&type=style&index=0&id=c5b319a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5b319a2"]])

export default __exports__